import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import {
    Typography, Box, useMediaQuery, useTheme
} from '@mui/material'
import Parser from 'html-react-parser';

import { useStyles } from './IdentityValidationStyles'

import { documentsActions, fileActions, workflowActions, addTitleLegoCurrent } from '../../store/actions'
import { UseImage, CustomLoadingOverlay, GenericContainer, Buttons ,GenericContainerForm} from '../../components'
import { HandType, ApiUrl, ApiIdentyUrl, coreFunctions } from '../../utils'
import Indice_rightImg from '../../assets/Indice_right.jpg'
import Indice_leftImg from '../../assets/Indice_left.jpg'
import { useTranslation } from 'react-i18next';

export default function HelpFingertComponent(props) {
    const matches = useMediaQuery('(min-width:650px)');
    const theme = useTheme()
    const location = useLocation()
    const localStyles = useStyles()
    const navigate = useNavigate()

    const [folioId, setFolioId] = useState(0)
    const [capturedFinger, setCapturedFinger] = useState(0)
    const [capturedCurrentFinger, setCapturedCurrentFinger] = useState("")

    const [loadView, setLoadView] = useState(false)
    // const [validaCaptura, setValidaCaptura] = useState(false)
    // const [timerSeconds, setTimerSeconds] = useState(30)
    //Ventana que se abre para captura de minucias
    const [isFlowGroup, setIsFlowGroup] = useState(false)
    const [actorIdCurrent, setActorIdCurrent] = useState(null)
    const [sections, setSections] = useState([])
    const [loadStatusStage, setLoadStatusStage] = useState(false)

    const file = useSelector(state => state.FileInfo)
    const registroStatusStage = useSelector(state => state.RegStatusStage)
    const dispatch = useDispatch()
    const { t } = useTranslation();

    useEffect(() => {
        dispatch(fileActions.GetFileInfo(location.state.folioId))
        setFolioId(location.state.folioId)
        console.log("location.state.capturedFinger-----------------: ", location.state.capturedFinger)
        setCapturedFinger(location.state.capturedFinger === undefined ? 0 : location.state.capturedFinger)
    }, [])


    useEffect(() => {
        capturedFinger == 0 ? setCapturedCurrentFinger(HandType.LEFT) : setCapturedCurrentFinger(HandType.RIGHT)
        dispatch(addTitleLegoCurrent(capturedFinger == 0 ? 'Dedo índice, mano izquierda' : 'Dedo índice, mano derecha'))
    }, [capturedFinger])

    useEffect(() => {
        if (file.items != undefined) {
            console.log("file info----------------------: ", file.items)
            setFolioId(file.items.Id)
            let currentActorValue = file.items?.Stage?.CurrentActor?.Id
            console.log("file.items-------------setActorIdCurrent--------------------: ", currentActorValue)
            setActorIdCurrent(currentActorValue)

            const secs = file.items.Stage?.DocumentalCategory?.DocumentalGroups[0]?.DocumentTypes[0]?.Sections
            const sectionsValue = secs?.filter((sec) => sec.CaptureType == "Minutiae")
            console.log("secs-------------sectionsValue---------------------: ", sectionsValue)
            setSections(sectionsValue)

            if (file.items.Product == "Solicitud Grupal") {
                setIsFlowGroup(true)
            }
            // let actGeoloc = file.items.Stage.Properties.find(item => item.Name == "ActiveGeolocation")?.Value
            // console.log("actGeoloc-----PARAM--- CONFIG------ ", actGeoloc)
            // setActiveGeolocation(actGeoloc === undefined ? true : actGeoloc)
        }
    }, [file])

    useEffect(() => {
        console.log("registroStatusStage.items------- ", registroStatusStage.items)
        setLoadView(registroStatusStage.loading)
        if (registroStatusStage.items != undefined && registroStatusStage.items != null && loadStatusStage) {
            setLoadStatusStage(false)
            const nextComponent = 'ExternalValidations'
            coreFunctions.DoNextStage({ navigate, nextComponent, State: { folioId } })
        }
    }, [registroStatusStage])

    const handleCapture = () => {
        //params= folioId: 121312 Typo de captura: finger, Indica el dedo Izquierdo a derecho: 1, 
        //Indica el section Id= 23, Indica skipActor: true, inidca Actor Id: null

        let skipActor = (isFlowGroup ? null : true)
        let sectionIdValue = capturedFinger == 0 ? sections.find(item => item.CaptureOptions == "{\"FingerNumber\":7}")?.Id : sections.find(item => item.CaptureOptions == "{\"FingerNumber\":2}")?.Id

        let wihe = 'width=' + window.screen.availWidth + ',height=' + window.screen.availHeight;
        let win = window.open(`${ApiIdentyUrl.fingerAI}app?params=${folioId}_finger_${capturedFinger}_${sectionIdValue}_${skipActor}_${actorIdCurrent}_${encodeURI(ApiUrl.ambient)}_${sessionStorage.getItem('token')}`, '_blank', "screenX=1,screenY=1,left=1,top=1," + wihe);

        let pollTimer = window.setInterval(function () {
            console.log("Espea de cierre de ventana------------------- ", win?.closed)
            if (win.closed != false) { // != is required for compatibility with Opera                
                window.clearInterval(pollTimer);
                if (capturedFinger == 1) {
                    dispatch(workflowActions.RegisterStatusStage({
                        File_id: folioId,
                        Status: "Validación"
                    }))
                    setLoadStatusStage(true)
                } else {
                    let nextComponent = 'HelpFingertComponent'
                    let capturedFinger = 1
                    coreFunctions.DoNextStage({ navigate, nextComponent, State: { folioId, capturedFinger } })
                    setCapturedFinger(1)
                }
            }
        }, 2000);
    }

    const handleNoCapture = () => {
        const nextComponent = 'SkipJustificationMinutiae'
        coreFunctions.DoNextStage({ navigate, nextComponent, State: { folioId, capturedFinger } })
    }

    return (<GenericContainer>
        <GenericContainerForm>
        {/* <Typography
            variant="h6"
            gutterBottom> <b>{capturedFinger == 0 ? 'Dedo índice, mano izquierda' : 'Dedo índice, mano derecha'} </b></Typography> */}
        <Typography
            variant={!matches ? "subtitle2" : "subtitle1"}
            gutterBottom>
            {capturedFinger == 0 ?
                Parser("Coloca tu dedo índice izquierdo frente a la cámara del teléfono (aproximadamente a ocho centimetros), espera a que enfoque y realice la captura automaticamente.")
                : Parser("Coloca tu dedo índice derecho frente a la cámara del teléfono (aproximadamente a ocho centimetros), espera a que enfoque y realice la captura automaticamente.")
            }
        </Typography>
        <Box style={{
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            width: '100%',
            justifyContent: 'flex-end',
            padding: "1em",
        }}>
            <UseImage src={capturedFinger == 0 ? Indice_leftImg : Indice_rightImg} className={localStyles.imgFinger} />
        </Box>
        </GenericContainerForm>
        <Buttons ConfirmButtonText={capturedFinger == 0 ? 'Capturar indice izquierdo' : 'Captura indice derecho'}
            onClickConfirm={handleCapture}
            onClickCancel={handleNoCapture}
            CancelButtonText="No capturar" />

        {loadView ?
            <CustomLoadingOverlay active={loadView} text={t("general_loading_message")} />
            : null}
    </GenericContainer>)
}